import React, { memo } from "react"

import { Search, SendBox, Tab, ToolBox } from "@shared/components"
import { useChatInfo, useSchedule } from "@shared/contexts"

import ManagerMessages from "./ManagerMessages"
import UserMessages from "./UserMessages"
import CheckButton from "../../@shared/components/chat/CheckButton";

function Messages() {
  const { isSearchBarEnabled, chatMenu } = useChatInfo()
  const { schedule } = useSchedule()

  const isUserGroup = chatMenu === "USER"
  const isManagerGroup = chatMenu === "MANAGER"
  const isPaidSchedule = schedule?.paymentInformation === "PAID"
  const isAllSchedule = schedule?.paymentInformation === "ALL"

  const showSendBox = (schedule?.isChatEnabled && isUserGroup) || (schedule?.isChatEnabled && (isManagerGroup && isPaidSchedule))

  const header = [
    <Tab key="tab" isUser={true} />,
      <React.Fragment key="header">
        <ToolBox key="toolBox" isChatMode={true} />
        {isSearchBarEnabled && <Search key="search" isChatMode={true} />}
      </React.Fragment>
  ]
  return (
    <>
      <div className="fixB">{header}</div>
      <UserMessages isActive={isUserGroup} />
      <ManagerMessages isActive={isManagerGroup} />
      { showSendBox && <SendBox />}
      {!showSendBox && ((isAllSchedule && isUserGroup) || (!isAllSchedule && isManagerGroup)) && <CheckButton />}
    </>
  )
}

export default memo(Messages)
